<div class="subscription">
    <div class="cargo-credit my-5">
        @if (cargoCredit?.invalidPaymentMethod || isAccountOnHold) {
            <div
                class="container-template h-100 d-flex align-items-normal justify-content-center flex-column container-template-small"
            >
                @if (isAccountOnHold) {
                    <p class="mat-subtitle-2">
                        Account on credit hold. Contact
                        <a [href]="'mailto:support@cargosprint.com' | sanitize: 'url'"> support&#64;cargosprint.com </a>
                    </p>
                } @else {
                    <div>
                        <app-logo-payment-method
                            [paymentMethodName]="paymentMethodsEnum.SPRINTPAY_FLEX"
                            width="12em"
                            alt="SprintPay logo"
                        />
                        <p class="mat-subtitle-2 mt-3">
                            This account does not have a Maximum Balance Limit. A SprintPay account with a Maximum
                            Balance Limit must be setup in order to use this AutoPay feature. Contact
                            <a [href]="'mailto:support@cargosprint.com' | sanitize: 'url'">
                                support&#64;cargosprint.com
                            </a>
                        </p>
                    </div>
                }
            </div>
        } @else {
            <app-cargo-credit-internal [containerSizeClass]="'small'" [externalMessage]="true">
                @if (!cargoCredit?.availableCredit) {
                    <div class="mat-subtitle-2">
                        You do not have sufficient funds to enroll this MAWB in AutoPay. Contact
                        <a [href]="'mailto:support@cargosprint.com' | sanitize: 'url'">support&#64;cargosprint.com</a>
                    </div>
                } @else {
                    <div class="mat-subtitle-2">
                        Please ensure there are sufficient funds available at the time AGI Cargo makes your shipment
                        available to be paid.
                    </div>
                }
            </app-cargo-credit-internal>
        }
    </div>
</div>
